export default __webpack_public_path__ + "static/media/style.7020fd31.less";